import { render, staticRenderFns } from "./PreliminaryResults.vue?vue&type=template&id=548ffec0"
import script from "./PreliminaryResults.vue?vue&type=script&lang=js"
export * from "./PreliminaryResults.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports